module.exports = __webpack_public_path__ + "img/emoji-sick-noeyebrownes-240x240.1f0188c4.png";